import { Notifications } from "@/components/Notifications/Notifications";
import React from "react";
import { useSearchParams } from "react-router-dom";

const NotificationsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const drawerParam = searchParams.get("drawer") || undefined;
  const closeOnBack = drawerParam === "true";
  return <Notifications closeOnBack={closeOnBack} />;
};

export default NotificationsPage;
